import React, { useState } from "react";
import SearchInput from "@components/input/SearchInput";
import styled from "@emotion/styled";
import TabWithPanel from "@components/tab/TabWithPanel";
import { BrandTab, CategoryTab } from "@pages/search/_components";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const InputWrapper = styled.div({
  padding: "2rem",
});

const Search = () => {
  const [inputValue, setInputValue] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") === "brand" ? "2" : "1";
  const { t } = useTranslation();

  const handleTabChange = (key: string) => {
    const tabValue = key === "2" ? "brand" : "category";
    setSearchParams({ tab: tabValue });
  };

  const item = [
    {
      label: t("카테고리"),
      key: "1",
      children: <CategoryTab />,
    },
    {
      label: t("브랜드"),
      key: "2",
      children: <BrandTab />,
    },
  ];

  return (
    <Container>
      <InputWrapper>
        <SearchInput
          placeholder="아이템, 셀러 브랜드 명, 키워드 검색"
          inputValue={inputValue}
          setInputValue={setInputValue}
        />
      </InputWrapper>
      <TabWithPanel
        item={item}
        defaultValue={initialTab}
        onChange={handleTabChange}
      />
    </Container>
  );
};

export default Search;
